<template>
  <div>
    <div class="header-component opacity-header">
      <router-link :to="{name: 'Home'}" class="logo">
        <img src="../assets/logo.png" alt="">
      </router-link>
      <ul class="navigation">
        <router-link :to="{name: 'Home'}">
          <li>
            <div class="dot" id="dot-home"></div>
            <div class="nav-title" id="nav-home">首页</div>
          </li>
        </router-link>
        <router-link :to="{name: 'Business'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title" id="nav-business">业务体系</div>
          </li>
        </router-link>
        <router-link :to="{name: 'Products'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title" id="nav-products">业务范围</div>
          </li>
        </router-link>
        <router-link :to="{name: 'Team'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title">团队</div>
          </li>
        </router-link>
        <router-link :to="{name: 'News'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title">新闻动态</div>
          </li>
        </router-link>
        <router-link :to="{name: 'Blitz'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title">闪电扩张</div>
          </li>
        </router-link>
        <router-link :to="{name: 'Contact'}">
          <li>
            <div class="dot"></div>
            <div class="nav-title">联系我们</div>
          </li>
        </router-link>
      </ul>
    </div>
  </div>

</template>
<style lang="scss" src="./Header.scss"></style>
<script>

export default {
  watch: {
    $route (to, from) {
      window.scrollTo(0, top)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue